import React, { FC } from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import SEO from '../components/seo'
// import Bio from "../components/bio"
import PostCard from '../components/postCard'

import '../style/normalize.css'
import '../style/all.scss'
import { PostI, SiteMetadataI } from '../types/data-models'
import { AllFileQueryI, AllMarkdownRemarkI } from '../types/common'
//TODO: get rid of comments, remove unnecessary components, export as draft template

interface BlogIndexI {
  data: {
    site: {
      siteMetadata: SiteMetadataI
    }
    posts: AllMarkdownRemarkI<PostI>
    thumbnails: AllFileQueryI
  }
}
const BlogIndex: FC<BlogIndexI> = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const posts = data.posts.nodes
  let postCounter = 0

  return (
    <Layout title={siteTitle}>
      <SEO title="Blog" keywords={[`devlog`, `blog`, `gatsby`, `javascript`, `react`]} />
      {/* <Bio /> */}
      {data.site.siteMetadata.description && (
        <header className="page-head">
          <h2 className="page-head-title">{data.site.siteMetadata.description}</h2>
        </header>
      )}
      <div className="post-feed">
        {posts.map((post) => {
          postCounter++
          return <PostCard key={post.fields.slug} count={postCounter} node={post} postClass={`post`} />
        })}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }
    posts: allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM D, YYYY")
          title
          description
          tags
          thumbnail {
            url
            label
          }
        }
      }
    }
    thumbnails: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
      edges {
        node {
          relativePath
          sourceInstanceName
          childImageSharp {
            gatsbyImageData(width: 1360, quality: 100, placeholder: BLURRED)
          }
          publicURL
        }
      }
    }
  }
`

export default BlogIndex
